import { FilterExpression } from '@osos/shared/api';
import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { RefProperty } from '../ref-property.model';
import { DataEntityActionPresenterModel } from './data-entity-action-presenter.model';
import { DataViewsPresenterModel } from './data-views-presenter.model';
import { DataEntityPresenterModel } from './entity-presenter.model';

export class SystemButtonDataPresenterModel {
  id?: string;
  dataEntity: string;
  specificationVersion: number;
  state: 0 | 1 | 2;

  /**
   * The reference property to the Data Entity
   */
  relatedTo: RefProperty;
  /**
   * Icon of the button
   */
  name: LocalizedValueModel;
  description?: LocalizedValueModel;
  query?: RefProperty;
  criteria?: FilterExpression;
  icon: IconModel;
  nonMatchEntriesMode?: SystemButtonNonMatchEntriesMode;
  /**
   * The definition might be different based on the type of the button
   */
  relevantAction: {
    executorType?: string;
    /**
     * The type of the relevant Action Type
     */
    type: RelevantActionTypeEnum;
    triggerName?: LocalizedValueModel;
    /**
     * The id of the trigger to execute in case type is CustomEvent
     */
    triggerId?: string;

    isTriggerDisabled?: boolean;
    /**
     * The redirection of the button after execution in case the relevant action type is Redirect
     */
    redirection?: SystemButtonRedirection;
    /**
     * The redirection of the button after success execution in case the relevant action type is CustomEvent
     */
    successRedirection?: SystemButtonRedirection;
    /**
     * The redirection of the button after failure execution in case the relevant action type is CustomEvent
     */
    failureRedirection?: SystemButtonRedirection;
    fieldsMapping?: SystemButtonFieldMapping[];
    overrideFieldsMappingLockedFields?: boolean;
    uiEvent?: boolean;
    executionIndicator?: {
      mode?: ExecutionIndicatorModeEnum;
    };
    messages?: {
      /**
       * The message to be displayed when the system button is started
       */
      startMessage: LocalizedValueModel;
      /**
       * The message to be displayed when the system button is successful
       */
      successMessage: LocalizedValueModel;
    };
  };
  /**
   * The action types that this button can perform (single, bulk, collection, etc...)
   */
  actionTypes: ButtonActionTypeEnum[];
  /**
   * Whether the button is visible or not.
   */
  isPublished: boolean;
}

export enum RelevantActionTypeEnum {
  CustomEvent = 0,
  Redirect = 1,
}
export enum ButtonRedirectionTypeEnum {
  RelatedEntries = 0,
  SameView = 1,
  Url = 2,
  Entity = 3,
}
export enum ButtonRelationRedirectionTargetEnum {
  EntriesList = 0,
  ShowEntryDetails,
  CreateEntry,
  UpdateEntry,
}
export enum ButtonActionTypeEnum {
  SingleEntry = 0,
  DataCollection = 1,
  MultipleEntries = 2,
}

export enum ExecutionIndicatorModeEnum {
  None = 0,
  Informative = 1,
  Blocking = 2,
}
export class SystemButtonActionWithOptions {
  actions: DataEntityActionPresenterModel[];
  askUserEntity: DataEntityPresenterModel;
  askUserView?: DataViewsPresenterModel;
}
export interface SystemButtonRedirection {
  /**
   * The type of the redirection
   */
  type: ButtonRedirectionTypeEnum;
  /**
   * The relation id for the redirection if the type is relatedEntries.
   */
  relationId?: string;
  /**
   * The relation redirection target if the type is relatedEntries.
   */
  relationRedirectionTarget?: ButtonRelationRedirectionTargetEnum;
  /**
   * The URL to navigate to in case type is URL.
   */
  url?: string;
}
export interface SystemButtonFieldMapping {
  /**
   * The field normalized name
   */
  fieldName: string;
  valueType: FieldValueTypeEnum;
  /**
   * Field normalized name in original entry triggering event or set to a fixed value in case type is manual
   */
  value: any;
}

export enum FieldValueTypeEnum {
  NotSet = 0,
  Default,
  Manual = 2,
  Dynamic,
  /**
   * Not used for now
   */
  Expression,
  Pointer = 5,
}
export enum SystemButtonNonMatchEntriesMode {
  Disable = 0,
  Hidden = 1,
}

export interface SystemButtonStateForEntriesPresenterModel {
  isDisabled?: boolean;
  isHidden?: boolean;
  systemButtonId?: string;
}
